import { render, staticRenderFns } from "./Box9.vue?vue&type=template&id=29ba6438&scoped=true&"
import script from "./Box9.vue?vue&type=script&lang=js&"
export * from "./Box9.vue?vue&type=script&lang=js&"
import style0 from "./Box9.vue?vue&type=style&index=0&id=29ba6438&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ba6438",
  null
  
)

export default component.exports